import React, {ReactNode} from "react";
import {motion} from "framer-motion";
import "./Category.css"

const Category: React.FC<{ children: ReactNode }> = ({children}) => {
    return <>
        <motion.div
        initial={{opacity: 0}}
        whileInView={{opacity: 1.0}}
        transition={{duration: 2.0}}
        >
            <div className={"page"}>
                {children}
            </div>
        </motion.div>
    </>;
};

export default Category;
